/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Note } from '../../models/note';

export interface GetNote$Params {
  noteId: string;
  entityId: string;
  entityClass: 'Form' | 'FormQualitySection';
}

export function getNote(
  http: HttpClient,
  rootUrl: string,
  params: GetNote$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Note>> {
  const rb = new RequestBuilder(rootUrl, getNote.PATH, 'get');
  if (params) {
    rb.path('noteId', params.noteId, {});
    rb.path('entityId', params.entityId, {});
    rb.path('entityClass', params.entityClass, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Note>;
    })
  );
}

getNote.PATH = '/notes/{entityClass}/{entityId}/{noteId}';
